// extracted by mini-css-extract-plugin
export default {"hero":"ArticleHero_hero__m6ltu","title":"ArticleHero_title__E25kt","chip":"ArticleHero_chip__jUqZV","image":"ArticleHero_image__-dv-I","date":"ArticleHero_date__K2aMa"};